// 获取验证码
export function sendCodeMessage(that, data) {
  return that.$get("/sms/sendCodeMessage", data);
}

// 登录接口
export function getTestToken(that, data) {
  return that.$get("/wx/getTestToken", data);
}

// 绑定手机号
export function bindingTel(that, data) {
  return that.$post("/wx/bindingTel", data);
}

// 网页授权获取用户基本信息
export function getUserInfo(that, data) {
  return that.$post("/wx/getUserInfo", data);
}

// 余额记录
export function amount(that, data) {
  return that.$post("/data/amountPage", data);
}

// 兑换记录
export function gift(that, data) {
  return that.$post("/data/gift", data);
}

// 标记送达
export function update(that, data) {
  return that.$post("/data/update", data);
}

// 积分记录
export function integral(that, data) {
  return that.$post("/data/integralPage", data);
}

// 订单记录
export function order(that, data) {
  return that.$post("/data/order", data);
}

// 订单详情
export function orderInfo(that, data) {
  return that.$post("/data/orderInfo", data);
}

// 销售额数据
export function salesVolume(that, data) {
  return that.$post("/statistic/salesVolume", data);
}

// 会员数据
export function memberTotal(that, data) {
  return that.$post("/statistic/memberTotal", data);
}

// 当前在售产品
export function onSale(that, data) {
  return that.$post("/statistic/page", data);
}

// 库存告急产品
export function alarmList(that, data) {
  return that.$post("/statistic/alarmList", data);
}

// 茶艺师销售额排名
export function teaer(that, data) {
  return that.$post("/statistic/teaer", data);
}

// 当月最佳销售单品排名
export function singleProduct(that, data) {
  return that.$post("/statistic/product", data);
}

// 当月最具价值会员排名
export function member(that, data) {
  return that.$post("/statistic/member", data);
}

// 获取用户信息
export function getCodeByWx(that, data) {
  return that.$post("/wx/getUserInfo", data);
}


// WEBPACK FOOTER //
// ./src/api/api.js